import React, { useState, useEffect } from "react";
import "./Home.css";

const Home = ({ scrollToSection }) => {
  const images = [
    "/images/gallery/youtube_1.jpg",
    "/images/gallery/youtube_2.jpg",
    
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  // Change image every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section id="home" className="hero-section mt-10">
      {/* Background Video */}
      <video className="hero-video" autoPlay loop muted playsInline>
        <source src="/videos/hero.mp4" type="video/mp4" />
      </video>

      {/* Overlay Content */}
      <div className="hero-overlay">
        <h1 className="hero-title">LATHA STUDIOS</h1>
        <p className="hero-tagline">Capturing Your Precious Moments Forever</p>

        <button
          className="cta-button"
          onClick={() => scrollToSection && scrollToSection("contact")}
        >
          Book Now
        </button>

        {/* Single Centered Slider Below Button */}
       {/* Single Centered Slider Below Button */}
<div className="center-slider">
  {currentIndex === 0 ? (
    <a 
      href="https://youtube.com/live/9-Rze6UCYBw" 
      target="_blank" 
      rel="noopener noreferrer"
    >
      <img
        key={currentIndex}
        src={images[currentIndex]}
        alt="slider-img"
        className="center-slider-img"
        style={{ cursor: "pointer" }}
      />
    </a>
  ) : (
    <img
      key={currentIndex}
      src={images[currentIndex]}
      alt="slider-img"
      className="center-slider-img"
    />
  )}
</div>

      </div>
    </section>
  );
};

export default Home;
